/**
 * Spielanleitungen: filtert die Karten nach dem eingegebenen Spielnamen.
 *
 * Groß-/Kleinschreibung, Umlaute und Akzente spielen keine Rolle:
 * "hueter", "huter" und "Hüter" finden alle "Hüter des Schatzes".
 */
if (!customElements.get('ars-game-instructions')) {
  customElements.define(
    'ars-game-instructions',
    class ArsGameInstructions extends HTMLElement {
      connectedCallback() {
        this.search = this.querySelector('[data-search]');
        this.input = this.querySelector('[data-search-input]');
        this.clearButton = this.querySelector('[data-search-clear]');
        this.status = this.querySelector('[data-search-status]');
        this.empty = this.querySelector('[data-search-empty]');
        this.emptyQuery = this.querySelector('[data-search-query]');
        this.items = Array.from(this.querySelectorAll('[data-search-text]')).map((element) => ({
          element,
          text: ArsGameInstructions.normalize(element.dataset.searchText),
        }));

        if (!this.search || !this.input) return;

        this.search.hidden = false;
        this.input.addEventListener('input', () => this.filter());
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.input.value) {
            event.preventDefault();
            this.clear();
          }
        });
        this.clearButton?.addEventListener('click', () => this.clear());
        this.querySelector('[data-search-reset]')?.addEventListener('click', () => this.clear());

        // Browser stellen den Suchbegriff nach "Zurück" teilweise wieder her
        if (this.input.value) this.filter();
      }

      static normalize(value) {
        return (value || '')
          .toLowerCase()
          .replace(/ß/g, 'ss')
          .replace(/([aou])e/g, '$1')
          .normalize('NFD')
          .replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();
      }

      filter() {
        const query = ArsGameInstructions.normalize(this.input.value);
        const terms = query ? query.split(' ') : [];
        let visible = 0;
        let revealed = 0;

        this.items.forEach(({ element, text }) => {
          const match = terms.every((term) => text.includes(term));
          // Wieder eingeblendete Karten spielen die Einblend-Animation (animations.js) erneut ab;
          // sie bekommen eine neue, fortlaufende Reihenfolge statt der ursprünglichen Verzögerung
          if (match && element.hidden) {
            element.style.setProperty('--animation-order', revealed);
            revealed += 1;
          }
          element.hidden = !match;
          if (match) visible += 1;
        });

        if (this.clearButton) this.clearButton.hidden = !this.input.value;
        if (this.empty) this.empty.hidden = visible > 0;
        if (this.emptyQuery) this.emptyQuery.textContent = this.input.value.trim();
        if (this.status) {
          // Ohne Treffer zeigt der Hinweis darunter alles Nötige, der Status wird dann nur vorgelesen
          this.status.classList.toggle('visually-hidden', terms.length > 0 && visible === 0);
          if (!terms.length) {
            this.status.textContent = '';
          } else if (visible === 0) {
            this.status.textContent = `Keine Spielanleitung für „${this.input.value.trim()}“ gefunden`;
          } else {
            this.status.textContent = `${visible} von ${this.items.length} ${this.items.length === 1 ? 'Spiel' : 'Spielen'}`;
          }
        }
      }

      clear() {
        this.input.value = '';
        this.filter();
        this.input.focus();
      }
    }
  );
}
